import Backbone from 'backbone';
import CommunityContentUserModel from '../models/communitycontent-user-model';

const CommunityContentUsersCollection = Backbone.Collection.extend({
  model: CommunityContentUserModel,
});

export default CommunityContentUsersCollection;
